import { NodeBoxButton, NodeBoxButtonProps } from "../../Misc/Buttons/NodeBoxButton";

export function TimeButton(props: Omit<NodeBoxButtonProps, "children">) {
  return <NodeBoxButton {...props}><i className="fa fa-clock" /></NodeBoxButton>
}